var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'n-info': _vm.clickable }, 'n-ellipsis']},[_c('span',{class:{ 'n-link': _vm.clickable },attrs:{"title":_vm.label},on:{"click":function($event){$event.stopPropagation();_vm.clickable ? _vm.onClick() : null}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }